import React, { type FunctionComponent } from 'react'
import { AccountIcon, CategoryIcon, HomeIcon, ItemIcon, SparkleIcon } from '@instacart/ids-core'
import { NavFolder } from 'gin-and-tonic/containers/nav/components/NavFolder'
import { AdminNavEntryPoint } from 'gin-and-tonic/containers/nav/utils/adminNavConfig'
import { NavItem } from 'gin-and-tonic/containers/nav/components/NavItem'
import { BannersAdminAccessControl } from 'domains/banners/BannersAdminSection.configuration'
import { AccountManagementAdminAccessControl } from 'domains/account-management/AccountManagementAdminSection.configuration'

export const AdminNavMainContent: FunctionComponent = () => (
  <React.Fragment>
    <NavItem title="app.admin.nav.links.home" route="app-admin" Icon={HomeIcon} />

    <NavFolder
      Icon={SparkleIcon}
      title="app.admin.nav.links.campaignManagement"
      navEntryPoint={AdminNavEntryPoint.CampaignManagement}
    />

    <NavFolder
      Icon={CategoryIcon}
      title="merchandising.title"
      navEntryPoint={AdminNavEntryPoint.Merchandising}
    >
      <NavItem
        title="bannersDomain.title"
        route="app-admin-banners-list"
        accessControl={BannersAdminAccessControl}
      />
    </NavFolder>

    <NavFolder
      Icon={CategoryIcon}
      title="app.admin.nav.links.lps"
      navEntryPoint={AdminNavEntryPoint.LandingPageSystem}
    />

    <NavFolder
      title="app.admin.nav.links.catalogAdmin"
      Icon={ItemIcon}
      navEntryPoint={AdminNavEntryPoint.CatalogAdmin}
    />

    <NavItem
      title="app.admin.nav.links.accounts"
      route="app-admin-account-management"
      Icon={AccountIcon}
      accessControl={AccountManagementAdminAccessControl}
    />
  </React.Fragment>
)
